import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import ArchiveSection from "../components/ArchiveSection";
import VaultSection from "../components/VaultSection";
import ContactSection from "../components/ContactSection";
import VideoModal from "../components/VideoModal";
import Footer from "../components/Footer";
import { tapes } from "../mock/mock";

const Portfolio = () => {
  const [activeTape, setActiveTape] = useState(null);
  const [activeCategory, setActiveCategory] = useState("All");
  const revealRefs = useRef([]);

  const openTape = (tape) => setActiveTape(tape);
  const closeTape = () => setActiveTape(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("in");
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const filtered =
    activeCategory === "All"
      ? tapes
      : tapes.filter((t) => t.category === activeCategory);

  return (
    <div className="relative min-h-screen bg-[#0e0b09] text-[#f2ece1] overflow-x-hidden">
      <Navbar />
      <Hero
        tapes={tapes}
        onSelectTape={openTape}
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        filtered={filtered}
      />
      <AboutSection />
      <ArchiveSection tapes={tapes} onSelectTape={openTape} />
      <VaultSection onSelectTape={openTape} />
      <ContactSection />
      <Footer />
      <VideoModal tape={activeTape} onClose={closeTape} />
    </div>
  );
};

export default Portfolio;
